import { Alert, Form, Modal } from "react-bootstrap";
import { formatDataTime } from "../../../Utils/DateFormat";
import React, { useEffect, useState } from "react";
import { emptyError, handleErrors } from "../../Errors";
import DatePicker from "react-datepicker";
import { it } from "date-fns/locale/it";
import { setHours, setMinutes } from "date-fns";
import { FiMapPin, FiClock, FiFileText, FiCalendar, FiTrash2, FiPlus, FiEdit2, FiCheck } from "react-icons/fi";

const s = {
    modal: {
        borderRadius: 10,
        border: 'none',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    },
    header: {
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '20px 24px 16px',
        position: 'relative',
    },
    closeBtn: {
        position: 'absolute',
        top: 14,
        right: 16,
        background: 'none',
        border: 'none',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '1.3rem',
        cursor: 'pointer',
        lineHeight: 1,
        padding: 0,
    },
    title: {
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        margin: 0,
    },
    modeBadge: {
        display: 'inline-block',
        background: 'rgba(255,255,255,0.12)',
        color: '#a8c0e8',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '3px 10px',
        borderRadius: 20,
        marginTop: 6,
    },
    body: {
        padding: '20px 24px',
        background: '#fff',
    },
    fieldGroup: {
        marginBottom: 14,
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        color: '#9ca3af',
        marginBottom: 6,
    },
    input: {
        width: '100%',
        padding: '8px 12px',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        fontSize: '0.875rem',
        color: '#1a1a2e',
        background: '#fff',
        outline: 'none',
        transition: 'border-color 0.15s',
    },
    footer: {
        padding: '12px 24px 16px',
        background: '#fff',
        borderTop: '1px solid #f0f2f5',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
    },
    btnSecondary: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 18px',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        background: '#fff',
        color: '#6b7280',
        cursor: 'pointer',
    },
    btnPrimary: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 18px',
        borderRadius: 8,
        border: 'none',
        background: '#3b6fd4',
        color: '#fff',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    },
    btnDanger: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 18px',
        borderRadius: 8,
        border: 'none',
        background: '#fee2e2',
        color: '#dc2626',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        marginRight: 'auto',
    },
};

const ModalCalendarTraining = (props) => {
    const [teamId, setTeamId] = useState();
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [deadlineDate, setDeadlineDate] = useState(null);

    useEffect(() => {
        if (props.errors) handleErrors(props.errors);
    }, [props.errors]);

    useEffect(() => {
        if (props.eventDetail) {
            setStartDate(new Date(props.eventDetail.start));
            setEndDate(new Date(props.eventDetail.end));
            setDeadlineDate(props.eventDetail.deadline ? new Date(props.eventDetail.deadline.replace(' ', 'T')) : null);
        } else {
            setDeadlineDate(null);
            if (props.selectedInfoDay) {
                const utcDate = new Date(props.selectedInfoDay.start);
                const localDate = new Date(utcDate.getTime());
                setStartDate(setHours(setMinutes(new Date(localDate), 0), 9));
                setEndDate(setHours(setMinutes(new Date(utcDate), 0), 10));
            }
        }
    }, [props.selectedInfoDay, props.eventDetail]);

    const handleAddTraining = (e) => {
        e.preventDefault();
        emptyError();
        const emptyfields = document.querySelector('span.error_empty_field');
        const obj = {
            team_id: props.id ? props.id : teamId,
            location: document.querySelector("input[name=title]").value,
            description: document.querySelector("textarea").value,
        };
        let start = formatDataTime(new Date(startDate));
        let end = formatDataTime(new Date(endDate));
        obj.start_time = start.slice(0, 19).replace('T', ' ') + ':00';
        obj.end_time = end.slice(0, 19).replace('T', ' ') + ':00';
        obj.deadline = deadlineDate ? formatDataTime(new Date(deadlineDate)).slice(0, 19).replace('T', ' ') + ':00' : null;
        obj.players_limit = document.querySelector("input[name=players_limit]").value || null;
        if (!emptyfields) props.setNewEvent(obj);
    };

    const handleEditTraining = (e) => {
        e.preventDefault();
        emptyError();
        const emptyfields = document.querySelector('span.error_empty_field');
        const obj = {
            team_id: props.eventDetail.team_id && teamId,
            location: document.querySelector("input[name=title]").value,
            id: document.querySelector("input[name=id]").value,
            description: document.querySelector("textarea").value,
        };
        let start = formatDataTime(new Date(startDate));
        let end = formatDataTime(new Date(endDate));
        obj.start_time = start.slice(0, 19).replace('T', ' ') + ':00';
        obj.end_time = end.slice(0, 19).replace('T', ' ') + ':00';
        obj.deadline = deadlineDate ? formatDataTime(new Date(deadlineDate)).slice(0, 19).replace('T', ' ') + ':00' : null;
        obj.players_limit = document.querySelector("input[name=players_limit]").value || null;
        if (!emptyfields) props.setEditedEvent(obj);
    };

    return (
        <Modal show={props.showModal} onHide={props.handleCloseModal} aria-labelledby="modal-title" centered>
            <div style={s.modal}>
                {/* Alerts */}
                {props.errors && typeof props.errors === 'string' && (
                    <Alert variant="danger" onClick={() => props.setErrors(null)} dismissible className="mb-0 rounded-0">
                        {props.errors}
                    </Alert>
                )}
                {!props.errors && props.generalError && typeof props.generalError === 'string' && (
                    <Alert variant="danger" onClick={() => props.setGeneralError(null)} dismissible className="mb-0 rounded-0">
                        {props.generalError}
                    </Alert>
                )}

                {/* Header */}
                <div style={s.header}>
                    <button style={s.closeBtn} onClick={props.handleCloseModal}>×</button>
                    <p style={s.title}>{props.editMode ? 'Modifica allenamento' : 'Nuovo allenamento'}</p>

                </div>

                {/* Body */}
                <div style={s.body}>
                    <Form.Control type="hidden" name="team_id" defaultValue={props.eventDetail?.team_id || ''} />
                    <Form.Control type="hidden" name="id" defaultValue={props.eventDetail?.id || ''} />

                    {!props.id && !props.editMode && (
                        <div style={s.fieldGroup}>
                            <label style={s.label}>Team</label>
                            <Form.Select
                                required
                                name="team_id"
                                style={s.input}
                                onChange={(e) => setTeamId(e.currentTarget.value)}
                            >
                                <option value="">Seleziona Team</option>
                                {props.team?.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                            </Form.Select>
                        </div>
                    )}

                    <div style={s.fieldGroup}>
                        <label style={s.label}><FiMapPin size={11} /> Location</label>
                        <input
                            name="title"
                            type="text"
                            required
                            placeholder="Es. Campo centrale"
                            defaultValue={props.eventDetail?.title || ''}
                            style={s.input}
                        />
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                        <div>
                            <label style={s.label}><FiClock size={11} /> Inizio</label>
                            <DatePicker
                                wrapperClassName="w-100"
                                className="form-control form-control-sm"
                                showTimeSelect
                                dateFormat="d/MM/yyyy HH:mm"
                                name="start_time"
                                timeCaption="Orario"
                                locale={it}
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                excludeTimes={[
                                    setHours(setMinutes(new Date(), 0), 0),
                                    setHours(setMinutes(new Date(), 0), 1),
                                    setHours(setMinutes(new Date(), 30), 19),
                                    setHours(setMinutes(new Date(), 30), 17),
                                ]}
                            />
                        </div>
                        <div>
                            <label style={s.label}><FiClock size={11} /> Fine</label>
                            <DatePicker
                                wrapperClassName="w-100"
                                className="form-control form-control-sm"
                                showTimeSelect
                                dateFormat="d/MM/yyyy HH:mm"
                                timeCaption="Orario"
                                name="end_time"
                                locale={it}
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                            />
                        </div>
                    </div>

                    <div style={s.fieldGroup}>
                        <label style={s.label}><FiCalendar size={11} /> Deadline (opzionale)</label>
                        <DatePicker
                            wrapperClassName="w-100"
                            className="form-control form-control-sm"
                            showTimeSelect
                            dateFormat="d/MM/yyyy HH:mm"
                            timeCaption="Orario"
                            name="deadline"
                            locale={it}
                            selected={deadlineDate}
                            onChange={(date) => setDeadlineDate(date)}
                            isClearable
                            placeholderText="Seleziona deadline"
                        />
                    </div>

                    <div style={s.fieldGroup}>
                        <label style={s.label}>N. max di convocati (opzionale)</label>
                        <input
                            name="players_limit"
                            type="number"
                            min="1"
                            placeholder="Es. 15"
                            defaultValue={props.eventDetail?.players_limit || ''}
                            style={s.input}
                        />
                    </div>

                    <div style={s.fieldGroup}>
                        <label style={s.label}><FiFileText size={11} /> Descrizione</label>
                        <textarea
                            name="description"
                            placeholder="Descrizione allenamento..."
                            rows={3}
                            defaultValue={props.eventDetail?.description || ''}
                            style={{ ...s.input, resize: 'vertical' }}
                        />
                    </div>
                </div>

                {/* Success message */}
                {props.message && (
                    <div style={{
                        margin: '0 24px 12px',
                        padding: '10px 14px',
                        borderRadius: 8,
                        background: '#dcfce7',
                        color: '#16a34a',
                        fontSize: '0.82rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        cursor: 'pointer',
                    }} onClick={() => props.setMessage(null)}>
                        <FiCheck size={14} /> {props.message}
                    </div>
                )}

                {/* Footer */}
                <div style={s.footer}>
                    {props.editMode && (
                        <button style={s.btnDanger} onClick={props.handleEditEvent} data-id={props.eventDetail?.id}
                                disabled={props.isLoading}>
                            <FiTrash2 size={13} /> Elimina
                        </button>
                    )}
                    <button style={s.btnSecondary} onClick={props.handleCloseModal} disabled={props.isLoading}>
                        Chiudi
                    </button>
                    <button
                        style={{ ...s.btnPrimary, opacity: props.isLoading ? 0.75 : 1, minWidth: 130, justifyContent: 'center' }}
                        onClick={props.editMode ? handleEditTraining : handleAddTraining}
                        disabled={props.isLoading}
                    >
                        {props.isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status"
                                      style={{ width: 12, height: 12, borderWidth: 2 }} />
                                Salvataggio...
                            </>
                        ) : (
                            props.editMode
                                ? <><FiEdit2 size={13} /> Salva modifiche</>
                                : <><FiPlus size={13} /> Aggiungi</>
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalCalendarTraining;
